export default __webpack_public_path__ + "static/media/qualituAssuranceTheme.7fd12026.png";